export default __webpack_public_path__ + "static/emotion-b87292ffc06e9d61a4dcac4af26790b3.svg";